import IOfferProductVersionPost from 'api/interfaces/offers/IOfferProductVersionPost';

import api from './api';

export interface IOwnConfiguration {
  id: number;
  name: string;
}

export default {
  // The configurations the user has made, which the user may save over
  getOwn: (): Promise<IOwnConfiguration[]> =>
    api.get('/api/v1/products/configurations/own'),
  // A position alternative saved as a new configuration or over an own one
  post: (save: {
    configurationId: null | number;
    name: string;
    version: IOfferProductVersionPost;
  }): Promise<{ id: number }> =>
    api.post('/api/v1/products/configurations/from-position', save),
};
